import React, { useEffect, useMemo, useRef, useState } from "react";
import { Button, Col, Drawer, Row, Form, Modal } from "antd";
import {
  DesktopContentWrapper,
  SectionCard,
  SectionCardBody,
  SectionCardHeading,
  PriceModalContentWrapper,
  Wrapper,
  FooterActionWrapper,
  FooterActionItemWrapper,
  MobilePassengerDataWrapper,
  ContactWrapper,
  MobileContentBody,
  MobileContentFooter,
  Content,
  TravelGuideWarning,
  TravelGuideWarningTitle,
} from "./styles";
import PassengerHeaderNavigation from "../../components/HeaderNavigation/Passenger";

import { ReactComponent as BulbFilledIcon } from "../../assets/images/bulb-filled-icon.svg";
import FlightItinerarySummary from "../../components/FlightItinerary/FlightItinerarySummary";
import { StyledParagraph, StyledTitle, StyledText } from "../../components/CustomAntdComponents/Typography";
import FlightPaymentBreakdown from "../../components/FlightItinerary/FlightPaymentBreakdown";
import { ReactComponent as ArrowRightIcon } from "../../assets/images/caret-right.svg";
import FlightItinerary from "../../components/FlightItinerary";
import PassengerData from "./PassengerData";
import { ActionButtonWrapper, ActionContentWrapper, ActionFareWrapper } from "../../components/FlightItinerary/styles";
import useIsMobile from "../../hooks/useIsMobile";
import { ReactComponent as CaretUpIcon } from "../../assets/images/caret-up.svg";
import { ReactComponent as CaretDownIcon } from "../../assets/images/caret-down.svg";
import { ReactComponent as TagIcon } from "../../assets/images/tag.svg";
import AlertWarningIcon from "../../assets/images/pop_info.svg";
import {
  CentralizedContent,
  HorizontalAlignContent,
  SpaceBetweenAlignContent,
  VerticalAlignContent,
} from "../../components/CustomAntdComponents/Utitlities";
import { formatNumberAsCurrency } from "../../utils/helpers";
import { calculateFlightTotalFareFromSplitConfig,calculateTicketNewTotal, calculateTicketTotalOldPrice, } from "../../components/AvailableFlights/helper";
import { useFlightSearchStore } from "../../store/flightSearch/flightSearchStore";
import { useBookingStore } from "../../store/booking/bookingStore";
import ContactForm from "../../components/PassengerForm/ContactForm";
import PromoCodeInput from "../../components/PassengerForm/PromoCodeInput";
import { ReactComponent as PlusIcon } from "../../assets/images/plus.svg";
import { ReactComponent as EditIcon } from "../../assets/images/pencil.svg";
import { ReactComponent as ContactIcon } from "../../assets/images/contact.svg";
import AlertMessage from "../../components/AlertMessage";
import { buildPassengersPayload, getInitialFormData, savePassengerData, handleConfirmTicketPriceApiError } from "./helper";

import { StyledButton } from "../../components/CustomAntdComponents/StyledButton";
import { useI18nContext } from "../../utils/I18n";
import { ReactComponent as CloseIcon } from '../../assets/images/close.svg';
import { ReactComponent as PriceUpdateIcon } from '../../assets/images/price-update.svg';


import { CONFIRM_DOMESTIC_TICKET_URL, CONFIRM_TICKET_URL, GET_USER_TRAVELERS_URL } from "../../utils/constants";
import { useStore } from "../../store/global/appStore";
import { encryptedPostAPI, postAPI, getAPI } from "../../utils/api";
import { Link, useNavigate } from "react-router-dom";
import translations from "./translations";
import FlightRequestLoading from "../../components/RequestLoading";
import FlightFareBreakdown from "../../components/FlightItinerary/FlightFareBreakdown";
import { useAuthStore } from "../../store/auth/authStore";
import MobileCreditBanner from "../../components/FlightItinerary/MobileCreditBanner";
import { MobileDrawerContentDisclaimer } from "../../components/HeaderNavigation/Flight/styles";
import {
  PriceInformationMain,
  PriceInformationIconContainer,
  PriceInformationIconImage,
  PriceInformationTitle,
  PriceInformationMessage,
  CloseIconContainer,
} from "../../components/SearchPriceNotification/styles";
import { EncryptionHelper } from "../../utils/encryption";

function PassengerDetails() {
  const navigate = useNavigate();
  const {
    state: { t },
  } = useI18nContext();

  const [openDrawer, setOpenDrawer] = useState<boolean>(false);
  const [openContactDrawer, setOpenContactDrawer] = useState<boolean>(false);
  const [openPromoDrawer, setOpenPromoDrawer] = useState<boolean>(false);
  const [showPromoInput, setShowPromoInput] = useState<boolean>(false);
  const drawerContainerRef = useRef(null);
  const { isMobile } = useIsMobile();
  const { requesting, setRequesting } = useStore();
  const { setReservation } = useBookingStore();
  const [errorMessage, setErrorMessage] = useState<null | string>(null);
  const [errorFields, setErrorFields] = useState([]);
  const [priceUpdatedModal, setPriceUpdateModal] = useState(false);
  const [ticketReservation, setTicketReservation] = useState<ConfirmTicketResponse[] | null>(null);
  const [openDetailsNotification, setOpenDetailsNotification] = useState(false);
  const [gobackNotification, setGobackNotification] = useState<boolean>(false);
  const [formValues, setFormValues] = useState(null);

  const {
    selectedFlight,
    formData: { isDomestic },
    updateStoreData,
  } = useFlightSearchStore();
  const { totalTicketAmount } = calculateFlightTotalFareFromSplitConfig(selectedFlight, isDomestic);
  const { creditApplied, creditAmount, isLoggedIn, setTravelers } = useAuthStore();

  useEffect(() => {
    const fetchTravelers = async () => {
      if (!isLoggedIn) return;
      try {
        const response = await getAPI(GET_USER_TRAVELERS_URL);
        if (response.status === 200) {
          const authObj = localStorage.getItem("trips_auth");
          const obj: UserAuth = authObj ? JSON.parse(authObj) : null;
          const merchantHash = obj?.Hash;
          const merchantCode = obj?.MerchantCode;

          if (merchantHash && merchantCode && response.data) {
            const decrypted = await EncryptionHelper.decrypt(response.data, merchantHash, merchantCode);

            const parsed = JSON.parse(decrypted);
            const travelersList = parsed?.Data?.Items || [];
            setTravelers(travelersList);
          }
        }
      } catch (err) {
        console.error("Error fetching traveler profiles:", err);
      }
    };
    fetchTravelers();
  }, [isLoggedIn, setTravelers]);
  let creditDeducted = 0;
  let displayAmount = totalTicketAmount || 0;

  if (creditApplied && creditAmount > 0) {
    creditDeducted = Math.min(creditAmount, totalTicketAmount || 0);
    displayAmount = (totalTicketAmount || 0) - creditDeducted;
  }

  const flightType = isDomestic ? "domestic" : "international";
  const initialFormData = getInitialFormData();
  const auth = localStorage.getItem("trips_auth");
  const userData: UserAuth = JSON.parse(auth);


  const PriceUpdateButtons = (
    <SpaceBetweenAlignContent style={{ padding: "10px" }}>
      <Link to="/search-listings" style={{ width: "100%" }}>
        <StyledButton mode="default" block>
          {t(translations).cancel}
        </StyledButton>
      </Link>

      <StyledButton
        type="primary"
        block
        onClick={() => {
          setPriceUpdateModal(false);
          handleBookTicket();
        }}
      >
        {t(translations).proceed}
      </StyledButton>
    </SpaceBetweenAlignContent>
  );

  const PriceUpdatedContent = ticketReservation ? (
    <PriceModalContentWrapper>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: '16px', marginBottom: '24px' }}>
        <PriceUpdateIcon />
        <StyledTitle level={3} align="center" style={{ fontWeight: 600 }}>Price update</StyledTitle>
      </div>
      <StyledParagraph align="center" size="default">
        {t(translations).priceUpdate}
        &nbsp;
        {/* USE CURRENCY FROM CONFIG */}
        <StyledText color="primary">
          {`${formatNumberAsCurrency(
            calculateTicketTotalOldPrice(ticketReservation),
             userData.ExtraData.CurrencyCode
          )}`}
        </StyledText>{" "}
        {t(translations).to}
        &nbsp;
        <StyledText color="primary">
          {`${formatNumberAsCurrency(
            calculateTicketNewTotal(ticketReservation),
             userData.ExtraData.CurrencyCode
          )}`}
        </StyledText>
      </StyledParagraph>
    </PriceModalContentWrapper>
  ) : (
    <div>&nbsp;</div>
  );

  const buildBookingPayload = (data: any) => {
    if (data.length === undefined) {
      return data;
    }
    const [departure, arrival] = data;

    return { departure, arrival };
  };

  const handleBookTicket = async (payload?: any) => {
    const bookingDetails = buildBookingPayload(payload || ticketReservation);
    let bookingData;

    const { departure, arrival } = bookingDetails;
    const TicketingDetails: any = [
      {
        Price: departure?.NewPrice,
        ConfirmationCode: departure.ConfirmationCode,
        Hash: departure.Hash,
      },
    ];

    if (arrival) {
      TicketingDetails.push({
        Price: arrival.NewPrice,
        ConfirmationCode: arrival.ConfirmationCode,
        Hash: arrival.Hash,
      });
    }

    bookingData = {
      TripsType: flightType,
      TripsMode: "flight",
      Hash: departure.Hash,
      PassengerDetails: departure.PassengerDetails,
      TravelInformations: departure.TravelInformations,
      TicketingDetails,
    };

    setReservation(bookingData, "bookingPayload");
    navigate("/payment/flight");
  };

  const handleConfirmTicket = async (payload: any) => {
    setErrorMessage(null);
    setRequesting(true);
    try {
      
      const confirmURL = isDomestic ? CONFIRM_DOMESTIC_TICKET_URL : CONFIRM_TICKET_URL;
      const stringPayload = JSON.stringify(payload);

      const merchantKey = userData.Hash;
      const merchantCode = userData.MerchantCode;

      const encryptedPayload = await EncryptionHelper.encrypt(stringPayload, merchantKey, merchantCode);
      let confirmTicket = await encryptedPostAPI(confirmURL, encryptedPayload);

      

      if (confirmTicket.status === 200) {
        const response = confirmTicket.data.length === undefined ? [confirmTicket.data] : confirmTicket.data;
        const decryptResponse = await EncryptionHelper.decrypt(response, merchantKey, merchantCode);
        const confirmTicketData = JSON.parse(decryptResponse);

        const responseArray = Array.isArray(confirmTicketData)
          ? confirmTicketData
          : [confirmTicketData];
        const oldPrice = responseArray[0]?.OldPrice;
        const newPrice = responseArray[0]?.NewPrice;

        setTicketReservation(responseArray);
        setReservation(responseArray, "confirmData");
        setReservation(response, "encryptedBookingData");
        setRequesting(false);

        if (oldPrice < newPrice && payload.PromoCode) {
          await handleBookTicket(responseArray);
        } else if (oldPrice === newPrice) {
          await handleBookTicket(responseArray);
        } else {
          setPriceUpdateModal(true);
        }
      } else {
        setRequesting(false);
        let errorMessage = "Verification failed. Please check details and try again.";
        try {
          const decryptResponse = await EncryptionHelper.decrypt(confirmTicket.data, merchantKey, merchantCode);
          const errorResponse = JSON.parse(decryptResponse);
          errorMessage = handleConfirmTicketPriceApiError(errorResponse);
        } catch (decryptErr) {
          if (confirmTicket.data && typeof confirmTicket.data === "string") {
            errorMessage = confirmTicket.data;
          }
        }
        setErrorMessage(errorMessage);
        window.scrollTo(0, 0);
      }
    } catch (err: any) {
      setRequesting(false);
      console.error("Error during ticket confirmation:", err);
      setErrorMessage("An unexpected error occurred during ticket confirmation. Please try again.");
      window.scrollTo(0, 0);
    }
  };

  const handleOnFinish = (values: any) => {
    setErrorMessage(null);
    setErrorFields([]);
    setFormValues(values);

    setOpenDetailsNotification(true);
  };

  const handleMinizeNotification = () => {
    setOpenDetailsNotification(false);
    // setMinizedPriceNotification(true)
  };

  const handleContinueToPayment = () => {
    setOpenDetailsNotification(false);
    const values = formValues;
    if (selectedFlight) {
      const fullPhoneData = values.contactPhone.split(",");
      const bookingContact = {
        email: values.contactEmail.trim(),
        phone: fullPhoneData[0],
        country: fullPhoneData[1] || initialFormData.country,
      };

      if (Boolean(values["adults"][0].savePassengerData)) {
        savePassengerData({
          ...values.adults[0],
          contactEmail: bookingContact.email,
          contactPhone: bookingContact.phone,
          country: bookingContact.country,
        });
      }

      const payload = buildPassengersPayload(values, selectedFlight, bookingContact, isDomestic);
      updateStoreData({
        passengers: payload.AirTravellers,
        bookingContact,
      });
      handleConfirmTicket(payload);
    }
  };

  const [form] = Form.useForm();

  const hasContactError = useMemo(() => {
    return errorFields.some((field) => field.name[0] === "contactEmail" || field.name[0] === "contactPhone");
  }, [errorFields]);

  const watchContactEmail = Form.useWatch("contactEmail", form);
  const watchContactPhone = Form.useWatch("contactPhone", form);
  const watchPromoCode = Form.useWatch("promoCode", form);

  const hasContactDetails = useMemo(() => {
    return !!(watchContactEmail && watchContactPhone);
  }, [watchContactPhone, watchContactEmail]);

  if (requesting) {
    return <FlightRequestLoading booking />;
  }

  const renderAlertMessage = ({ onClick }) => (
    <PriceInformationMain>
      {/* close button */}
      <CloseIconContainer onClick={handleMinizeNotification}>
        <CloseIcon />
      </CloseIconContainer>

      <PriceInformationIconContainer>
        <PriceInformationIconImage src={AlertWarningIcon} alt="alert" />
      </PriceInformationIconContainer>

      <PriceInformationTitle>Please review your details carefully before proceeding to payment. </PriceInformationTitle>
      <PriceInformationMessage>Modifications will not be permitted after proceeding. Your booking confirmation and ticket will be sent to the email address provided.</PriceInformationMessage>

      <StyledButton style={{ width: "100%" }} mode="primary" onClick={onClick}>
        Continue to payment
      </StyledButton>
    </PriceInformationMain>
  );


  return (
    <>
      <div ref={drawerContainerRef}>
        {isMobile ? (
          <Form
            onFinish={handleOnFinish}
            initialValues={initialFormData}
            form={form}
            onFinishFailed={({ errorFields }) => {
              setErrorFields(errorFields);
            }}
            layout="vertical"
          >
            <Wrapper>
              <Content>
                <Row>
                  <Col span={24}>
                    <PassengerHeaderNavigation />
                  </Col>
                </Row>
                <MobileContentBody>
                  {errorFields.length > 0 && !errorMessage && (
                    <AlertMessage message="Please add all required information" closable={false} />
                  )}
                  {errorFields.length === 0 && errorMessage && <AlertMessage message={errorMessage} closable={false} />}
                  <Row>
                    <Col span={24}>
                      <div style={{ marginBottom: "10px" }}>
                        <StyledTitle level={4}>Add passenger information</StyledTitle>
                      </div>

                      <MobilePassengerDataWrapper>
                        <TravelGuideWarning>
                          <TravelGuideWarningTitle>
                            <BulbFilledIcon />
                            <StyledParagraph> Travel Guide </StyledParagraph>
                          </TravelGuideWarningTitle>
                          <span>Transit visa may be required based on your passport nationality and selected route. Please verify before departure.</span>
                        </TravelGuideWarning>
                        <PassengerData form={form} errorFields={errorFields} onSetErrorFields={setErrorFields} />
                      </MobilePassengerDataWrapper>
                    </Col>
                  </Row>

                  <Drawer
                    title="Contact Details"
                    placement="bottom"
                    onClose={() => setOpenContactDrawer(false)}
                    open={openContactDrawer}
                    forceRender
                    footer={
                      <StyledButton
                        type="primary"
                        block
                        onClick={() => {
                          form
                            .validateFields(["contactEmail", "contactPhone"])
                            .then(() => {
                              setOpenContactDrawer(false);
                              setErrorFields((prev) =>
                                prev.filter(
                                  (field) => field.name[0] !== "contactEmail" && field.name[0] !== "contactPhone"
                                )
                              );
                            })
                            .catch(() => { });
                        }}
                      >
                        Confirm
                      </StyledButton>
                    }
                    getContainer={document.getElementById("app-container") as HTMLElement}
                  >
                    <ContactForm />
                  </Drawer>

                  <Drawer
                    title="Promo code "
                    height={250}
                    placement="bottom"
                    onClose={() => setOpenPromoDrawer(false)}
                    open={openPromoDrawer}
                    forceRender
                    footer={
                      <StyledButton type="primary" block onClick={() => setOpenPromoDrawer(false)}>
                        Apply
                      </StyledButton>
                    }
                    getContainer={document.getElementById("app-container") as HTMLElement}
                  >
                    <div>
                      <PromoCodeInput />
                    </div>
                  </Drawer>

                  <Drawer
                    open={openDetailsNotification}
                    onClose={handleMinizeNotification}
                    // headerStyle={{ display: "none" }}
                    placement="bottom"
                    height="35%"
                    getContainer={document.getElementById("app-container") as HTMLElement}
                    closable={true}
                  >
                    <MobileDrawerContentDisclaimer>
                      {renderAlertMessage({ onClick: handleContinueToPayment })}
                    </MobileDrawerContentDisclaimer>
                  </Drawer>
                </MobileContentBody>
                <MobileContentFooter>
                  <FooterActionWrapper>
                    <FooterActionItemWrapper onClick={() => setOpenContactDrawer(true)}>
                      <ContactWrapper error={hasContactError} hasContactDetails={hasContactDetails}>
                        {hasContactDetails ? (
                          <>
                            <div>
                              <VerticalAlignContent>
                                <ContactIcon />
                                <StyledParagraph size="normal">Contact details</StyledParagraph>
                              </VerticalAlignContent>
                              <StyledParagraph>{`Email: ${watchContactEmail}`}</StyledParagraph>
                              <StyledParagraph>{`Mobile: ${watchContactPhone.split(",")[0]}`}</StyledParagraph>
                            </div>

                            <EditIcon height={16} width={16} />
                          </>
                        ) : (
                          <>
                            <VerticalAlignContent>
                              <ContactIcon />
                              <StyledParagraph size="default">
                                Add contact details <span>(Compulsory)</span>
                              </StyledParagraph>
                            </VerticalAlignContent>

                            <PlusIcon height={14} width={14} />
                          </>
                        )}
                      </ContactWrapper>
                    </FooterActionItemWrapper>

                    <FooterActionItemWrapper onClick={() => setOpenPromoDrawer(true)}>
                      {watchPromoCode ? (
                        <>
                          <div>
                            <VerticalAlignContent>
                              <TagIcon />
                              <StyledParagraph size="normal">Promo Code</StyledParagraph>
                            </VerticalAlignContent>
                            <StyledParagraph size="normal">{watchPromoCode}</StyledParagraph>
                          </div>

                          <EditIcon height={16} width={16} />
                        </>
                      ) : (
                        <>
                          <VerticalAlignContent>
                            <TagIcon />
                            <StyledParagraph size="default">
                              Add promo code <span>(If any)</span>
                            </StyledParagraph>
                          </VerticalAlignContent>

                          <PlusIcon height={14} width={14} />
                        </>
                      )}
                    </FooterActionItemWrapper>
                  </FooterActionWrapper>

                  <MobileCreditBanner promoCodeEntered={Boolean(watchPromoCode)} />

                  <ActionFareWrapper>
                    <SpaceBetweenAlignContent>
                      <StyledParagraph size="normal">Total for all passengers</StyledParagraph>
                      <CentralizedContent style={{ width: "100%", justifyContent: "flex-end", alignItems: "center" }}>
                        {creditApplied && creditDeducted > 0 && (
                          <StyledParagraph style={{ textDecoration: 'line-through', marginRight: '8px', color: '#9CA3AF' }}>
                            {formatNumberAsCurrency(totalTicketAmount || 0, selectedFlight[0]?.Currency)}
                          </StyledParagraph>
                        )}
                        <StyledTitle level={3}>
                          {formatNumberAsCurrency(displayAmount, selectedFlight[0]?.Currency)}
                          &nbsp;
                        </StyledTitle>
                        <CaretUpIcon width={17} height={17} onClick={() => setOpenDrawer(true)} style={{ marginLeft: '4px' }} />
                      </CentralizedContent>
                    </SpaceBetweenAlignContent>
                    <ActionContentWrapper style={{ marginTop: "15px" }}>
                      <ActionButtonWrapper>
                        <Button block size="large" type="primary" htmlType="submit">
                          Continue to payment
                        </Button>
                      </ActionButtonWrapper>
                    </ActionContentWrapper>
                  </ActionFareWrapper>
                </MobileContentFooter>
              </Content>
            </Wrapper>
          </Form>
        ) : (
          <>
            <Row>
              <Col span={24}>
                <PassengerHeaderNavigation />
              </Col>
            </Row>
            <Row>
              <Col xs={0} lg={24}>
                <DesktopContentWrapper className="container">
                  {errorFields.length > 0 && !errorMessage && (
                    <AlertMessage message="Please add all required information" closable={false} />
                  )}
                  {errorMessage && <AlertMessage message={errorMessage} closable={false} />}
                  <Form
                    onFinish={handleOnFinish}
                    onFinishFailed={({ errorFields }) => {
                      setErrorFields(errorFields);
                    }}
                    form={form}
                    layout="vertical"
                    initialValues={initialFormData}
                  >
                    <Row>
                      <Col span={13}>
                        <SectionCard>
                          <SectionCardHeading onClick={() => setOpenDrawer(true)} clickable bordered>
                            <StyledTitle level={4}>Trip Itinerary</StyledTitle>
                            <ArrowRightIcon />
                          </SectionCardHeading>
                          <SectionCardBody>
                            <FlightItinerarySummary />
                          </SectionCardBody>
                        </SectionCard>

                        <SectionCard>
                          <SectionCardHeading>
                            <StyledTitle level={4}>Add passenger information</StyledTitle>
                          </SectionCardHeading>
                          <SectionCardBody>
                            <TravelGuideWarning>
                              <TravelGuideWarningTitle>
                                <BulbFilledIcon />
                                <StyledParagraph> Travel Guide </StyledParagraph>
                              </TravelGuideWarningTitle>
                              <StyledParagraph size="default" style={{ color: "#667085", }}> Transit visa may be required based on your passport nationality and selected route. Please verify before departure.</StyledParagraph>
                            </TravelGuideWarning>
                            <PassengerData form={form} errorFields={errorFields} onSetErrorFields={setErrorFields} />
                          </SectionCardBody>
                        </SectionCard>

                        <SectionCard>
                          <SectionCardHeading>
                            <StyledTitle level={4}>Add contact details</StyledTitle>
                          </SectionCardHeading>
                          <SectionCardBody>
                            <div style={{ marginBottom: "20px" }}>
                              <StyledParagraph size="default">
                                This is where we will send your booking details to. Please ensure they are correct.
                              </StyledParagraph>
                            </div>
                            <ContactForm />
                          </SectionCardBody>
                        </SectionCard>

                        <SectionCard>
                          <SectionCardHeading onClick={() => setShowPromoInput(!showPromoInput)} clickable>
                            <StyledTitle level={4}>Add promo code</StyledTitle>
                            {showPromoInput ? <CaretUpIcon /> : <CaretDownIcon />}
                          </SectionCardHeading>
                          <SectionCardBody>{showPromoInput && <PromoCodeInput />}</SectionCardBody>
                        </SectionCard>
                      </Col>
                      <Col offset={2} span={9}>
                        <FlightPaymentBreakdown promoCodeEntered={Boolean(watchPromoCode)} />
                      </Col>
                    </Row>
                  </Form>
                </DesktopContentWrapper>
              </Col>
            </Row>

            <Modal
              open={openDetailsNotification}
              closable={false}
              maskClosable={false}
              // footer={PriceUpdateButtons}
              footer={null}
              title=""
              onCancel={() => setOpenDetailsNotification(false)}
              centered
              getContainer={document.getElementById("app-container") as HTMLElement}
              className="custom-rounded-modal"
            >
              {renderAlertMessage({ onClick: handleContinueToPayment })}
            </Modal>

            <Modal
              open={gobackNotification}
              closable={false}
              maskClosable={false}
              // footer={PriceUpdateButtons}
              footer={null}
              title=""
              onCancel={() => setOpenDetailsNotification(false)}
              centered
              getContainer={document.getElementById("app-container") as HTMLElement}
              className="custom-rounded-modal"
            >
              {renderAlertMessage({ onClick: handleContinueToPayment })}
            </Modal>
          </>
        )}
      </div>

      <Drawer
        title="Trip Summary"
        placement={isMobile ? "bottom" : "right"}
        onClose={() => setOpenDrawer(false)}
        open={openDrawer}
        height="100%"
        width={isMobile ? "100%" : "500px"}
        getContainer={drawerContainerRef.current as HTMLElement}
      >
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100%' }}>
          <div style={{ padding: "0 10px 20px" }}>
            <StyledParagraph size="default">Here are your trip details</StyledParagraph>
          </div>
          <div style={{ flex: 1 }}>
            <FlightItinerary hidePriceBreakdown />
          </div>
          <div style={{ background: '#FFF8F0', padding: "24px", margin: "24px -24px -24px -24px", marginTop: "auto" }}>
            <StyledTitle level={4} style={{ marginBottom: 16 }}>Price breakdown</StyledTitle>
            <FlightFareBreakdown hideBreakdown={false} />
          </div>
        </div>
      </Drawer>

      <Modal
        open={priceUpdatedModal}
        closable={true}
        maskClosable={false}
        footer={PriceUpdateButtons}
        title={null}
        onCancel={() => setPriceUpdateModal(false)}
        centered
        getContainer={document.getElementById("app-container") as HTMLElement}
        className="custom-rounded-modal"
      >
        {PriceUpdatedContent}
      </Modal>
    </>
  );
}

export default PassengerDetails;
